export default "/assets/fonts/EasyNotes.b8a85560fefe0099ec64c4a96be49717.woff2";